<div class="fg-form d-flex">
  <div class="container d-flex">
    <div class="row align-items-center justify-content-center" *ngIf="!showOtpVerify && !showToChangePassword">
      <div class="col-md-8 col-lg-6 col-xl-6">
        <div class="card overflow-hidden forgot-password-pages">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-white-50 p-4">
                  <h5 class="text-white-50"> Forgot Password</h5>
                  <p>Reset your password with Xpresion Next.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="card-body pt-0 fg-card">
            <!-- <div>
                <a routerLink="/">
                  <div class="avatar-md profile-user-wid mb-4">
                    <span class="avatar-title rounded-circle bg-light">
                      <img src="assets/images/logo.svg" alt="" class="rounded-circle" height="34">
                    </span>
                  </div>
                </a>
              </div> -->

            <form class="needs-validation" name="forgotPasswordForm" [formGroup]="forgotPasswordForm"
              (ngSubmit)="onFormSubmit()" novalidate>

              <ngb-alert type="danger" *ngIf="error" [dismissible]="false">{{ error }}</ngb-alert>

              <div class="mt-4 mb-4 form-group">
                <input type="text" class="form-control" id="clientid" maxlength="10" placeholder=""
                  formControlName="txtClientId"
                  [ngClass]="{ 'is-invalid': formSubmitted && forgotPasswordForm.get('txtClientId').errors }" />
                <label for="clientid" class="form-label">Client Id</label>
                <div *ngIf="formSubmitted && forgotPasswordForm.get('txtClientId').errors" class="invalid-feedback">
                  <div *ngIf="forgotPasswordForm.get('txtClientId').errors.required">
                    Client id is required
                  </div>
                </div>
              </div>

              <div class="mt-3 mb-3 form-group">


                <input type="email" formControlName="txtEmail" class="form-control" id="email" placeholder=""
                  [ngClass]="{ 'is-invalid': formSubmitted && forgotPasswordForm.get('txtEmail').errors }" />
                <label for="email" class="control-label text-white-50 form-label">Email</label>
                <div *ngIf="formSubmitted && forgotPasswordForm.get('txtEmail').errors" class="invalid-feedback">
                  <div *ngIf="forgotPasswordForm.get('txtEmail').errors.required">Email is required</div>
                  <div *ngIf="forgotPasswordForm.get('txtEmail').errors.pattern">Email must be a valid email address
                  </div>
                </div>
              </div>
              <div class="text-end">
                <button class="btn login-btn btn-block" type="submit">Generate OTP</button>
              </div>
            </form>

          </div>
        </div>
        <div class="mt-5 text-center">
          <p>Remember It ? <a routerLink="/account/login" class="fw-medium text-primary"> Sign In here</a> </p>
          <p class="mb-0">
            © {{ year }} Powered by
            <img width="100" src="assets/images/busisoft_logo.png" />
          </p>
        </div>

      </div>

    </div>
    <div class="row align-items-center justify-content-center flex-grow-1"
      *ngIf="showOtpVerify && !showToChangePassword">
      <div class="col-md-12 col-lg-6 col-xl-6">
        <div class="card overflow-hidden forgot-password-pages">

          <div class="card-body pt-0 fg-card">

            <div class="p-2">
              <div class="text-center">

                <div class="avatar-md mx-auto">
                  <div class="avatar-title rounded-circle bg-light">
                    <i class="bx bxs-envelope h1 mb-0 text-primary"></i>
                  </div>
                </div>
                <div class="p-2 mt-4">

                  <h4 class="text-white-50">Verify your email</h4>
                  <p class="mb-5">Please enter the 6 digit code sent to <span class="fw-semibold">{{userEmailId}}</span>
                  </p>

                  <form>
                    <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>

                  </form>

                  <div class="mt-4">
                    <a class="btn login-btn btn-block" (click)="cancelOtp()">Cancel</a>
                    <a class="btn login-btn btn-block" (click)="onFormSubmit()">Verify</a>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
        <div class="mt-5 text-center">
          <p>Did't receive a code ? <a href="javascript: void(0);" class="fw-medium text-primary" (click)="resendOTP()">
              Resend </a> </p>
          <p class="mb-0">
            © {{ year }} Powered by
            <img width="100" src="assets/images/busisoft_logo.png" />
          </p>
        </div>
      </div>
    </div>

    <div class="row align-items-center justify-content-center flex-grow-1" *ngIf="showToChangePassword">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden forgot-password-pages">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-white-50 p-4">
                  <!-- <h5 class="text-white-50"> Confirm Password</h5> -->
                  <p>Set your password with Xpresion Next.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="card-body pt-0 fg-card">

            <form class="needs-validation" name="confirmPasswordForm" [formGroup]="confirmPasswordForm"
              (ngSubmit)="onFormSubmit()">
              <div class="mt-4 mb-4 form-group">
                <input type="{{ hidePassword ? 'password' : 'text' }}" class="form-control" id="password" placeholder=""
                  formControlName="txtPassword"
                  [ngClass]="{ 'is-invalid': isConfirmFormSubmitted && confirmPasswordForm.get('txtPassword').errors }" />
                <label for="password" class="control-label text-white-50 form-label">Password</label>
                <button class="btn bg-transparent text-white border position-absolute top-0 border-opacity-50 form-icon"
                  type="button" id="password" (click)="hidePassword=!hidePassword">
                  <i [class]="hidePassword ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline' "></i>
                </button>

                <div *ngIf="isConfirmFormSubmitted && confirmPasswordForm.get('txtPassword').errors"
                  class="invalid-feedback">
                  <div *ngIf="confirmPasswordForm.get('txtPassword').errors.required"> Password is required </div>
                  <div *ngIf="confirmPasswordForm.get('txtPassword').errors.maxlength"> Maximum length exceeded (20 characters). </div>
                  <div *ngIf="confirmPasswordForm.get('txtPassword').errors.minlength"> Must be at least 8 characters long. </div>
                  <div *ngIf="confirmPasswordForm.get('txtPassword').errors.requiresSpecialChars"> Must contain at least 1 special character </div>
                  <div *ngIf="confirmPasswordForm.get('txtPassword').errors.requiresDigit"> Must contain at least 1 digit. </div>
                  <div *ngIf="confirmPasswordForm.get('txtPassword').errors.requiresUppercase">Must contain at least 1 uppercase.</div>
                  <div *ngIf="confirmPasswordForm.get('txtPassword').errors.requiresLowercase"> Must contain at least 1 lowercase.</div>
                </div>
              </div>

              <div class="mt-4 mb-4 form-group">
                <input type="{{ hideconfirmpassword ? 'password' : 'text' }}" class="form-control" id="password"
                  placeholder="" formControlName="txtConfirmPassword"
                  [ngClass]="{ 'is-invalid': isConfirmFormSubmitted && confirmPasswordForm.get('txtConfirmPassword').errors }" />
                <label for="confirmpassword" class="control-label text-white-50 form-label">Confirm Password</label>
                <button class="btn bg-transparent text-white border position-absolute top-0 border-opacity-50 form-icon"
                  type="button" id="password" (click)="hideconfirmpassword=!hideconfirmpassword">
                  <i [class]="hideconfirmpassword ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline' "></i>
                </button>

                <div *ngIf="isConfirmFormSubmitted && confirmPasswordForm.get('txtConfirmPassword').errors"
                  class="invalid-feedback">
                  <div *ngIf="confirmPasswordForm.get('txtConfirmPassword').errors.required"> Confirm Password is required </div>
                </div>

                <span
                  *ngIf="confirmPasswordForm.get('txtConfirmPassword').value && confirmPasswordForm.errors?.mismatch"
                  class="custom-error-message">
                  Passwords doesn't match.
                </span>
              </div>
              <div class="text-end">
                <button class="btn login-btn btn-block" type="submit">Confirm</button>
              </div>
            </form>

          </div>
        </div>
        <div class="mt-5 text-center">
          <p class="mb-0">
            © {{ year }} Powered by
            <img width="100" src="assets/images/busisoft_logo.png" />
          </p>
        </div>
      </div>
    </div>
  </div>

</div>
<!-- end page -->